import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ProductResource extends AuthenticatedResource {
  static urlRoot = 'organizations/:organization_id/products' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}